import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from 'reactstrap';

const TokenExpirationModal = ({ 
  timeRemaining, 
  onRenew, 
  onExpire, 
  isOpen = true 
}) => {
  const formatTimeRemaining = (milliseconds) => {
    const minutes = Math.floor(milliseconds / 60000);
    const seconds = Math.floor((milliseconds % 60000) / 1000);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <Modal isOpen={isOpen} centered backdrop="static" keyboard={false}>
      <ModalHeader>
        <i className="mdi mdi-clock-alert-outline text-warning me-2"></i>
        Sesión por Expirar
      </ModalHeader>
      <ModalBody>
        <Alert color="warning" className="mb-3">
          <i className="mdi mdi-information-outline me-2"></i>
          Su sesión expirará en {formatTimeRemaining(timeRemaining)} minutos.
        </Alert>
        <p className="mb-0">
          Para continuar trabajando, haga clic en "Renovar Sesión". 
          Si no renueva, será redirigido automáticamente al login.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button 
          color="secondary" 
          onClick={onExpire}
          className="me-2"
        >
          Cerrar Sesión
        </Button>
        <Button 
          color="primary" 
          onClick={onRenew}
        >
          <i className="mdi mdi-refresh me-1"></i>
          Renovar Sesión
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TokenExpirationModal;
